import { FormComponentProps } from "antd/lib/form";
import { AssignedGoal } from "../../../../cuba/entities/base/tsadv$AssignedGoal";
import { DicUOM } from "cuba/entities/base/tsadv$DicUOM";
import { WrappedFormUtils } from "antd/es/form/Form";

export type FormCreateCategoryKpi = {
  category: string;
  goalString: string;
  weight: number;
  startDate?: string;
  endDate?: string;
  successCriteria: string;
  id?: string;
  goalType?: string;
  maxPercentReduction?: number;
  uomAssignedGoal?: DicUOM;
  assignedGoalType: GOAL_TYPE_EFFECTIVE;
};

export type InitialKpiFormData =
  | FormCreateCategoryKpi
  | FormCreateLibraryKpi
  | FormCreateCascadeKpi;

export type FormCreateLibraryKpi = {
  category: string;
  goal: string;
  goalLibrary: string;
  goalString: string;
  successCriteria: string;
  goalSuccessCriteria: string;
  weight: number;

  startDate?: string;
  endDate?: string;
  id?: string;
  uomAssignedGoal?: DicUOM;
  goalType?: string;
  maxPercentReduction?: number;
  assignedGoalType: GOAL_TYPE_EFFECTIVE;
};

export type FormCreateCascadeKpi = {
  goalString: string;
  successCriteria: string;
  weightBase: number;

  name: string;
  description: string;
  groupId: string;
  weight: number;
  uomAssignedGoal?: DicUOM;
  maxPercentReduction?: number;
  goalType?: string;
  assignedGoalType: GOAL_TYPE_EFFECTIVE;
};

export type FormGradeProps = {
  approverHrRoleCode: string;
  isGradeStage: boolean;
  statusRequest: string;
  parentForm: WrappedFormUtils<any>;
};

export interface BaseProps extends FormComponentProps {
  isInitiator: boolean;
  assignedGoal: AssignedGoal;
  nameField: string;
  enabled: boolean;
}

export interface ChangeAssesmentResultProps extends BaseProps {
  isCommentsDisabled: boolean;
  useInCBA: boolean;
}

export interface ChangeAssasmentManagerResultProps
  extends Omit<BaseProps, "isInitiator" | "enabled"> {
  isCommentsDisabled: boolean;
  managerEnabled: boolean;
  isManager: boolean;
  isDeprematization?: boolean;
}

export type GoalHistoryData = {
  id: string;
  from?: string | null;
  to?: string | null;
  kpiName?: string | null;
  description?: string | null;
  weight?: any | null;
  result?: any | null;
  children?: GoalHistoryData[] | null;
};

export enum GOAL_TYPE_EFFECTIVE {
  EFFECTIVE = "EFFECTIVE",
  DEPREMATIZATION = "DEPREMATIZATION",
}
